"use strict";
var core_1 = require('@angular/core');
var ToastOptions = (function () {
    function ToastOptions(options) {
        this.newestOnTop = false;
        this.animate = 'fade';
        this.enableHTML = false;
        this.showCloseButton = false;
        Object.assign(this, options);
    }
    ToastOptions.decorators = [
        { type: core_1.Injectable },
    ];
    /** @nocollapse */
    ToastOptions.ctorParameters = [
        { type: Object, },
    ];
    return ToastOptions;
}());
exports.ToastOptions = ToastOptions;
//# sourceMappingURL=toast-options.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ng2-toastr/src/toast-options.js
// module id = 158
// module chunks = 1